import type {
  CloseOrderRevisionSessionRequest,
  OrderRevisionBoardPageResponse,
  OrderRevisionRequestCategory,
  OrderRevisionSession,
  ReplyOrderRevisionRequestRequest,
} from "../../../domain/types/order-revision-request";
import type { CompanyOrderRevisionRequestApiService } from "../../api/company/company-order-revision-request-api-service";
import { companyOrderRevisionRequestApiService } from "../../api/company/company-order-revision-request-api-service";

export interface CompanyOrderRevisionRequestRepository {
  getOrderRevisionSessions(
    companyId: number,
    params: {
      category?: OrderRevisionRequestCategory;
      closed?: boolean;
      keyword?: string;
      page?: number;
      size?: number;
    }
  ): Promise<OrderRevisionBoardPageResponse>;

  getOrderRevisionSessionDetail(
    companyId: number,
    sessionId: number
  ): Promise<OrderRevisionSession>;

  sendAdminMessage(
    companyId: number,
    sessionId: number,
    request: ReplyOrderRevisionRequestRequest
  ): Promise<OrderRevisionSession>;

  updateAdminMessage(
    companyId: number,
    messageId: number,
    request: ReplyOrderRevisionRequestRequest
  ): Promise<OrderRevisionSession>;

  deleteAdminMessage(
    companyId: number,
    messageId: number
  ): Promise<OrderRevisionSession>;

  closeSession(
    companyId: number,
    sessionId: number,
    request: CloseOrderRevisionSessionRequest
  ): Promise<OrderRevisionSession>;

  reopenSession(companyId: number, sessionId: number): Promise<OrderRevisionSession>;
}

export class CompanyOrderRevisionRequestRepositoryImpl
  implements CompanyOrderRevisionRequestRepository
{
  constructor(private apiService: CompanyOrderRevisionRequestApiService) {}

  async getOrderRevisionSessions(
    companyId: number,
    params: {
      category?: OrderRevisionRequestCategory;
      closed?: boolean;
      keyword?: string;
      page?: number;
      size?: number;
    }
  ): Promise<OrderRevisionBoardPageResponse> {
    return this.apiService.getOrderRevisionSessions(companyId, params);
  }

  async getOrderRevisionSessionDetail(
    companyId: number,
    sessionId: number
  ): Promise<OrderRevisionSession> {
    return this.apiService.getOrderRevisionSessionDetail(companyId, sessionId);
  }

  async sendAdminMessage(
    companyId: number,
    sessionId: number,
    request: ReplyOrderRevisionRequestRequest
  ): Promise<OrderRevisionSession> {
    return this.apiService.sendAdminMessage(companyId, sessionId, request);
  }

  async updateAdminMessage(
    companyId: number,
    messageId: number,
    request: ReplyOrderRevisionRequestRequest
  ): Promise<OrderRevisionSession> {
    return this.apiService.updateAdminMessage(companyId, messageId, request);
  }

  async deleteAdminMessage(
    companyId: number,
    messageId: number
  ): Promise<OrderRevisionSession> {
    return this.apiService.deleteAdminMessage(companyId, messageId);
  }

  async closeSession(
    companyId: number,
    sessionId: number,
    request: CloseOrderRevisionSessionRequest
  ): Promise<OrderRevisionSession> {
    return this.apiService.closeSession(companyId, sessionId, request);
  }

  async reopenSession(companyId: number, sessionId: number): Promise<OrderRevisionSession> {
    return this.apiService.reopenSession(companyId, sessionId);
  }
}

export const companyOrderRevisionRequestRepository =
  new CompanyOrderRevisionRequestRepositoryImpl(
    companyOrderRevisionRequestApiService
  );
